"use client";

import { Skeleton } from "@/components/ui/skeleton";

export function FormSkeleton() {
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 overflow-auto">
        <div className="p-6 space-y-6">
          { }
          <Skeleton className="h-7 w-48" />
          
          { }
          <Skeleton className="h-16 w-full rounded-lg" />
          
          { }
          <div className="space-y-4">
            <Skeleton className="h-5 w-40" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton />
            </div>
          </div>
          
          { }
          <div className="space-y-4">
            <Skeleton className="h-5 w-44" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton className="md:col-span-2" tall />
            </div>
          </div>
          
          { }
          <div className="space-y-4">
            <Skeleton className="h-5 w-28" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton />
              <FieldSkeleton />
            </div>
          </div>
          
          { }
          <Skeleton className="h-4 w-48" />
        </div>
      </div>
      
      { }
      <div className="border-t bg-white p-4 flex justify-end gap-2">
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-32" />
      </div>
    </div>
  );
}

function FieldSkeleton({ className, tall }: { className?: string; tall?: boolean }) {
  return (
    <div className={`space-y-2 ${className || ''}`}>
      <Skeleton className="h-4 w-24" />
      <Skeleton className={tall ? "h-20 w-full" : "h-10 w-full"} />
    </div>
  );
}
